export default __webpack_public_path__ + "static/media/MS002.17daa94d.mp3";